const getPrices = (orderLineItem)=>{
    var ref, ref1, ref2, ref3;
    var _subtotal;
    const lineItemOriginalPrice = (_subtotal = (ref = orderLineItem.price) === null || ref === void 0 ? void 0 : ref.total.subtotal) !== null && _subtotal !== void 0 ? _subtotal : 0;
    var _gross;
    const totalPaid = (_gross = (ref1 = orderLineItem.price) === null || ref1 === void 0 ? void 0 : ref1.total.gross) !== null && _gross !== void 0 ? _gross : 0;
    var ref4;
    const discount = (ref4 = (ref3 = (ref2 = orderLineItem.price) === null || ref2 === void 0 ? void 0 : ref2.total.discount) === null || ref3 === void 0 ? void 0 : ref3.amount) !== null && ref4 !== void 0 ? ref4 : 0;
    var ref5;
    return {
        originalPrice: lineItemOriginalPrice,
        discountPrice: discount,
        price: (ref5 = totalPaid !== null && totalPaid !== void 0 ? totalPaid : lineItemOriginalPrice) !== null && ref5 !== void 0 ? ref5 : 0
    };
};

export { getPrices };
//# sourceMappingURL=get-prices.js.map
